<template>
  <li class="dropdownItem dropdownItem__customerInfo">
    <a
      class="dropdownItem__toggle user-profile dropdown-toggle"
      href="javascript:;"
      data-toggle="dropdown"
      aria-expanded="true"
    >
      客戶資料
      <span class="dropdownItem__icon fa fa-angle-down"></span>
    </a>
    <ul class="dropdown-menu dropdown-usermenu pull-right">
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="'/serviceMain/customerList'"
        >
          乘客資料
        </router-link>
      </li>
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="'/serviceMain/companyList'"
          v-if="hasEnterpriseSignPermission()"
        >
          企業資料
        </router-link>
      </li>
      <li class="dropdownItem__listItem">
        <router-link class="dropdownItem__href" :to="'/serviceMain/storeList'">
          特約店家
        </router-link>
      </li>
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="'/serviceMain/landmarkList'"
        >
          自建地標
        </router-link>
      </li>
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="'/serviceMain/teamBuildLocation'"
        >
          自建交叉路口
        </router-link>
      </li>
    </ul>
  </li>
</template>

<script>
import { hasTeamRole } from '@/utils/teamRoleAuth'
export default {
  methods: {
    hasEnterpriseSignPermission() {
      return hasTeamRole('enterprise_sign')
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'src/scss/_dropdownItem.scss';
</style>



// WEBPACK FOOTER //
// src/components/dropDown/DropdownCustomerInfo.vue